import { render } from "./NhlScores.vue?vue&type=template&id=4f722cad&scoped=true"
import script from "./NhlScores.vue?vue&type=script&lang=js"
export * from "./NhlScores.vue?vue&type=script&lang=js"

import "./NhlScores.vue?vue&type=style&index=0&id=4f722cad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f722cad"]])

export default __exports__